<template>
  <div class="this-home">
    <Logo height="75" padding="5,5,5,5" :light-theme="true" :one-line="false"></Logo>
    <span class="name">MICKAËL LARCHEVÊQUE</span>
    <span class="summary">{{ $t('home.summary') }}</span>
    <a href="#profile"><button class="btn-default">{{ $t('home.more') }}</button></a>
  </div>
</template>

<script>
import Logo from '../components/logo';
export default {
    name: 'Home',
    components: {
        Logo
    },
    props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-home {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 10vw;

    .name {
      color: $mainColor;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 60px;
      margin-bottom: 40px;
      margin-top: 20px;
    }

    .summary {
      color: $white;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 30px;
      margin-bottom: 40px;
      margin-top: 20px;
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-home {
      padding-top: 30px;
      .name {
        font-size: 30px;
      }

      .summary {
        font-size: 18px;
      }
    }
  }
</style>
